﻿import { h } from './element.mjs';
import { cssPrefix } from '../config.mjs';
import  svgIcon  from '../icons.mjs'; 
class Tool {
    constructor(name, onSelect = () => { }) {
        this.name = name;
        this.icon = svgIcon[name];
        this.onSelect = onSelect;

        this.el = h('button', `${cssPrefix}-tool tool-${this.name.toLowerCase()}`)
            .children(this.icon.render(),this.name);

        this.el.on('click', () =>  this.select() );
    }

    select() {
        this.el.addClass('tool-selected');
        this.onSelect(this);
    }

    deselect() {
        this.el.removeClass('tool-selected');
    }
}
export default class Toolbar {
    constructor(onToolSelected = () => { }) {
        this.onToolSelected = onToolSelected;
        this._ = [];
        this.clear = h('button', `${cssPrefix}-tool tool-close btn btn-secondary`).child('Done');
        this.clear.on('click', () => this.clearSelection());
        const toolList = ['textbox', 'combobox', 'checkbox', 'image'];// 'signature', 'text', 'radio',
         
        this._ = toolList.map( name => new Tool( name, (it) => this.selectTool(it)));
         
        this.el = h('div', `${cssPrefix}-toolbar`).children(
            h('div', `${cssPrefix}-tool-group`).children(
                ...this._.map(t => t.el)
            ), 
            this.clear
        );

        this.selectedTool = null;
    }

    selectTool(it) {
        if (this.selectedTool && this.selectedTool !== it) {
            this.selectedTool.deselect();
            return;
        }
        if (this.selectedTool && this.selectedTool == it) {
            this.selectedTool.deselect();
            this.selectedTool = null;
            this.onToolSelected(null);
            return;
        }
        this.selectedTool = it;
        this.onToolSelected(it.name);

    } 
    clearSelection() {
        this._.forEach(it => it.deselect());
        this.selectedTool = null;
        this.onToolSelected(null);
    }
     
}